import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  name: {
    marginBottom: "0.25rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  numberOfEvents: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  linkIcon: {
    marginRight: "6px",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    aspectRatio: "1",
    width: "40px",
    height: "40px",
    backgroundColor: theme.palette.events.blueShade2,
  },
  icon: {
    width: "24px",
    height: "20px",
  },
  innerContainer: {
    padding: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  },
  item: {
    height: "160px",
    textAlign: "center",
    borderRadius: "5px",
    padding: 0,
    cursor: "pointer",
    display: "flex",
    marginBottom: "8px",
    marginRight: "8px",
    flexDirection: "column",
    boxShadow: "4px 4px 4px 0px #0C38911A",
    position: "relative",
    maxWidth: "214px",
    minWidth: "200px",
    color: theme.palette.events.textPrimary,

    "&:hover $menuItem": {
      right: "0px",
      visibility: "visible",
      opacity: "1",
      zIndex: "1",
    },
  },
  menu: {
    display: "flex",
    justifyContent: "flex-end",
  },
  menuItem: {
    padding: "2px",
    background: "rgba(72, 74, 86, 0.75)",
    color: theme.palette.white,
    width: "32px",
    height: "32px",
    boxSizing: "border-box",
    borderRadius: "4px",
    display: "flex",
    visibility: "hidden",
    right: "-10px",
    opacity: "0",
    margin: "auto 3px",
    transition: "all 0.2s ease-in-out",

    "&:hover": {
      background: "rgba(72, 74, 86, 0.75)",
    },

    "@media (hover: none)": {
      right: "0",
      visibility: "visible",
      opacity: "1",
    },
  },
  menuItemSVG: {
    // resorting to !important here, as IconButtonWithTooltip is applying
    // styles to svgs with really high specificity that we can't beat.
    // Alternatively we'd use nested selectors for this
    width: "100%!important",
    height: "100%!important",
    fill: `${theme.palette.white}!important`,
    maxWidth: "24px",
  },
  cardHeaderRoot: {
    display: "flex",
    padding: "16px",
    alignItems: "center",
    position: "absolute",
    width: "100%",
    boxSizing: "border-box",
  },
  cardHeaderActions: {
    flex: "1 0 100%",
    position: "relative",
    $menu: {},
  },
}));
